module.exports = __webpack_public_path__ + "img/x-solid.46390b01.svg";